export const SBB_WEB = "SBB_WEB";
export const SBB_BRANCH = "SBB_BRANCH";
// export const SBB_BANKER = "SBB_BANKER";
export const SBB_CAFE = "SBB_CAFE";
// export const SBB_MOBILE = "SBB_MOBILE";

export const validChannelsQuery = [SBB_WEB, SBB_BRANCH, SBB_CAFE];
